import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { PoApproverHelperService } from '../../../services/po-approver-helper.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-view-po-history',
  templateUrl: './view-po-history.component.html',
  styleUrls: ['./view-po-history.component.scss']
})
export class ViewPoHistoryComponent implements OnInit {

  public title !: string;
  public qesData !: any;
  public po_number !:any;
  public line_item_no !:any;
  
  
   /******** Ag Grid Variables **********/
   public gridApi: any;
   public gridColumnApi: any;
   public frameworkComponents: any;
   public context: any;
   public gridOptions: GridOptions = {
     defaultColDef: {
       editable: false,
       sortable: true,
       flex: 1,
       minWidth: 250,
       filter: true,
       resizable: true,
       autoHeight: true,
       wrapText: true
     },
     suppressContextMenu: false,
     suppressMenuHide: false,
     sideBar: "true",
     rowGroupPanelShow: 'always',
     headerHeight: 40,
     pagination: true,
     paginationPageSize: 25,
     rowSelection: 'multiple',
     suppressCellSelection: true,
     overlayNoRowsTemplate: 'No results found.'
   }
   public columnDefs: (ColDef | ColGroupDef)[] = [];
   public rowData: any[] = [];
   @ViewChild('grid') grid!: AgGridWrapperComponent;

  constructor( private poApproverHelperService: PoApproverHelperService, private prBuyerHelperService:PrBuyerHelperService,
    public bsModalRef: BsModalRef,
    public _bsModalRef: BsModalRef,
    public modalService: BsModalService
  ) { 
    this.po_number = this.modalService.config.initialState?.["po_number"];
    this.line_item_no= this.modalService.config.initialState?.['line_item_no'];
  }

  ngOnInit(): void {
    this.poApproverHelperService.showPOconfirmationhistory(this.po_number,this.line_item_no).subscribe((res:any)=>{
      if(res){
        this.rowData =  res.data;
        console.log(this.rowData)
        this.columnDefs = this.prBuyerHelperService.getPoHistoryColumnDefs();
        console.log(this.columnDefs)
      }
    })
  }

  public onGridReady() {
    this.grid.autoSizeAll(true);
  }

}